export const isIOS = () => {
    return /iphone|ipad|ipod|ios|mac/.test(navigator.userAgent.toLowerCase())
}